var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.operating},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.goPath(item, index)}}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }